"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppDynamics = void 0;
const library_1 = require("../../core/library");
const helper_1 = require("../../core/library/helper");
const loader_1 = require("./loader");
class AppDynamics extends library_1.Library {
    constructor(appDynamicsKey) {
        super('AppDynamics', new loader_1.AppDynamicsLoader(appDynamicsKey));
        return (0, helper_1.withLibraryLoadCheck)(this);
    }
}
exports.AppDynamics = AppDynamics;
//# sourceMappingURL=index.js.map